import English from 'translations/en_US.json'
import French from 'translations/fr_CA.json'

import { isFrenchLocale } from 'app/utils/locales'

const getTranslationByLocale = (locale: string): Record<string, string> => {
  if (isFrenchLocale(locale)) {
    return French
  }

  return English
}

export default getTranslationByLocale
